import { Pipe, PipeTransform } from '@angular/core';
import { DictionaryService } from '@shared/dictionary/dictionary.service';
import { switchMap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LocaleService } from '@shared/dictionary/locale.service';

@Pipe({
  name: 'dictionary',
  pure: false
})
export class DictionaryPipe implements PipeTransform
{
  constructor(
    private dictionaryService: DictionaryService,
    private localeService: LocaleService
  ) { }

  transform(value: string): Observable<string>
  {
    return this.localeService.getLocale().pipe(
      switchMap(locale =>
        this.dictionaryService.getDictionary(locale).pipe(
          map(dictionaries =>
            dictionaries[locale] && dictionaries[locale][value] ? dictionaries[locale][value] : value
          )
        )
      )
    );
  }
}
